export const frontmatter = {
    "draft": false,
    "title": "Ticketing system",
    "description": "Ticketing system and customer support in OnnIA.",
    "sidebar_label": "Overview",
    "sidebar_group": "reference",
    "sidebar_order": 1
}

export const toc = []